import { LegView } from '@mopla/data-models';
import { getMoplaLegs } from '@mopla/utils';

import { IRatableLeg } from './types';

/** What a rating source knows about one leg. */
interface IRatableLegSource {
	rating?: number | null;
	driverName?: string;
}

/**
 * Numbers the MoPla legs of an itinerary and attaches what {resolve} knows about each
 */
export const buildRatableLegs = (
	legs: LegView[],
	resolve: (leg: LegView) => IRatableLegSource
): IRatableLeg[] => {
	const moplaLegs = getMoplaLegs(legs);

	return moplaLegs.map((leg, index) => {
		const { rating, driverName } = resolve(leg);

		return {
			legId: leg.legId,
			index: index + 1,
			total: moplaLegs.length,
			driverName,
			rating: rating ?? null,
		};
	});
};

/** The one leg a passenger can act on: the first still unrated. */
export const findActiveLeg = (ratableLegs: IRatableLeg[]): IRatableLeg | null =>
	ratableLegs.find(({ rating }) => rating === null) ?? null;
